import { p } from './core.js'

// Categoria 6 — Gaveteiros + Carrinhos (R3)
// SKUs: GAV-A..B (2), CARR-A..B (2) = 4 modelos
//
// Combos (COMBO-A..F) ficaram fora desta etapa por decisão de escopo —
// são bundles de outros SKUs e serão tratados separadamente.
//
// h_gav_comoda = 0.20, h_gav_buffet = 0.15.

export const GAVETEIROS = {

  // ── GAV-A — Gaveteiro Fixo (3 gavetas, sem rodízios) ────────────────────────
  'Gaveteiro': {
    entradas: ['C','P','A'],
    pecas: [
      p('Lateral',           '15', v => v.P * v.A, 2),
      p('Tampo',             '15', v => v.C * v.P, 1),
      p('Base',              '15', v => v.C * v.P, 1, 'branco'),
      p('Frente gaveta',     '15', v => v.C * 0.20, 3),
      p('Traseira gaveta',   '15', v => v.C * 0.20, 3, 'branco'),
      p('Lateral gaveta',    '15', v => v.P * 0.20, 6, 'branco'),
      p('Fundo do móvel',    '6',  v => v.C * v.A, 1),
      p('Fundo de gaveta',   '6',  v => v.C * v.P, 3),
    ],
    ferragens: { dobradica: 0, corredica: 3, pistao: 0, rodinha: 0, cabide: 0 },
  },

  // (GAV-B "Gaveteiro com Rodinhas" removido — cálculo divergia, fica fora do FORMINI)

  // ── CARR-A — Carrinho de Café (3 níveis abertos sobre rodízios, sem fundo) ──
  'Carrinho de Café': {
    entradas: ['C','P','A'],
    pecas: [
      p('Lateral',                  '15', v => v.P * v.A, 2),
      p('Tampo',                    '15', v => v.C * v.P, 1),
      p('Base',                     '15', v => v.C * v.P, 1),
      p('Prateleira intermediária', '15', v => v.C * v.P, 1),
    ],
    ferragens: { dobradica: 0, corredica: 0, pistao: 0, rodinha: 4, cabide: 0 },
  },

  // ── CARR-B — Carrinho de Café com 1 Gaveta (h_gav_buffet = 0.15) ────────────
  'Carrinho de Café com Gaveta': {
    entradas: ['C','P','A'],
    pecas: [
      p('Lateral',                  '15', v => v.P * v.A, 2),
      p('Tampo',                    '15', v => v.C * v.P, 1),
      p('Base',                     '15', v => v.C * v.P, 1),
      p('Prateleira intermediária', '15', v => v.C * v.P, 1),
      p('Frente gaveta',            '15', v => v.C * 0.15, 1),
      p('Traseira gaveta',          '15', v => v.C * 0.15, 1, 'branco'),
      p('Lateral gaveta',           '15', v => v.P * 0.15, 2, 'branco'),
      p('Fundo de gaveta',          '6',  v => v.C * v.P, 1),
    ],
    ferragens: { dobradica: 0, corredica: 1, pistao: 0, rodinha: 4, cabide: 0 },
  },
}
